import $http from '@/utitls/request'
/**
 * 获取用户填充信息
 */
export const GetUserFillList = (data) => {
    return $http.get('/api/User/GetUserFillList', { params: data })
}
/**
 * 分页获取用户信息
 */
export const GetUserPageList = (data) => {
    return $http.get('/api/User/GetUserPageList', { params: data })
}
/**
 * 分页获取用户剩余天数信息
 */
export const GetUseDayPageList = (data) => {
    return $http.get('/api/User/GetUseDayPageList', { params: data })
}
/**
 * 新增
 */
export const AddUser = (data) => {
    return $http.post('/api/User/AddUser', data)
}
/**
 * 修改
 */
export const EditUser = (data) => {
    return $http.put('/api/User/EditUser', data)
}
/**
 * 删除
 */
export const DeleteUser = (data) => {
    return $http.delete('/api/User/DeleteUser', { params: data })
}
/**
 * 重置账号密码
 */
export const ResetPass = (data) => {
    return $http.put('/api/User/ResetPass', null, { params: data })
}
/**
 * 验证密码
 */
export const ValidatePass = (data) => {
    return $http.put('/api/User/ValidatePass', null, { params: data })
}